module.exports = __webpack_public_path__ + "img/close.b7ff1314.png";